/*
 * Configuración global del store de Redux utilizando Redux Toolkit.
 */

import { configureStore } from '@reduxjs/toolkit';
import quoteReducer from '../features/quote/quoteSlice';
import vehicleReducer from '../features/vehicle/vehicleSlice';
import contractorReducer from '../features/contractor/contractorSlice';
import driverReducrer from '../features/driver/driverSlice';
import CoverageReducer from '../features/coverage/coverageSlice'
import InsuranceReducer from '../features/insurance/insuranceSlice'

import appReducer from '../features/app/appSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        quote: quoteReducer,
        vehicle: vehicleReducer,
        contractor: contractorReducer,
        driver: driverReducrer,
        coverage: CoverageReducer,
        insurance: InsuranceReducer
    },
    devTools: import.meta.env.MODE !== 'production',
});